(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qlp2-cycle-image"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.qcyc2Ready) return;
    root.dataset.qcyc2Ready='1';
    if(!('IntersectionObserver' in window)){ root.classList.add('is-in'); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{threshold:.2});
    io.observe(root);
  }

  function findBundle(extra){
    var sels=[];
    if(extra){ extra.split(',').forEach(function(s){ s=s.trim(); if(s) sels.push(s); }); }
    sels=sels.concat([
      '.kaching-bundles__block',
      '[data-deal-block-id]',
      'kaching-bundles',
      '.kaching-bundles',
      '[class*="kaching-bundles"]',
      '[data-qs-kaching-slot]'
    ]);
    var found=null;
    for(var i=0;i<sels.length;i++){
      var el=null;
      try{ el=document.querySelector(sels[i]); }catch(_){ el=null; }
      if(el){ if(el.offsetParent!==null) return el; if(!found) found=el; }
    }
    if(found) return found;
    var radio=document.querySelector('input[name^="kaching-bundles-deal"]');
    if(radio){ return radio.closest('[class*="kaching"]') || radio.closest('div') || radio; }
    return null;
  }

  function scrollToBundle(e){
    var a=e.currentTarget;
    var el=findBundle((a.getAttribute('data-target')||'').trim());
    if(el){
      e.preventDefault();
      var y=el.getBoundingClientRect().top+window.pageYOffset-120; // offset header sticky
      window.scrollTo({top:Math.max(0,y),behavior:'smooth'});
    }else{
      var href=a.getAttribute('href')||'';
      if(href==='' || href==='#'){ e.preventDefault(); } // pas de saut parasite
    }
  }
  function bindCta(scope){
    (scope||document).querySelectorAll('[data-qcyc2-cta]').forEach(function(b){
      if(b.dataset.qcyc2CtaReady) return;
      b.dataset.qcyc2CtaReady='1';
      b.addEventListener('click', scrollToBundle);
    });
  }

  document.querySelectorAll('[data-qcyc2]').forEach(init);
  bindCta(document);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('[data-qcyc2]'); if(el) init(el);
    bindCta(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qlp2-cycle"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.qcycReady) return;
    root.dataset.qcycReady='1';
    if(!('IntersectionObserver' in window)){ root.classList.add('is-in'); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{threshold:.25});
    io.observe(root);
  }
  document.querySelectorAll('[data-qlp2cyc]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('[data-qlp2cyc]'); if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qlp2-progress-timeline"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.qtsReady) return;
    root.dataset.qtsReady='1';
    if(!('IntersectionObserver' in window)){ root.classList.add('is-in'); return; }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    },{threshold:.15});
    io.observe(root);
  }
  document.querySelectorAll('[data-qts]').forEach(init);
  document.addEventListener('shopify:section:load',function(e){
    var el=e.target.querySelector('[data-qts]'); if(el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
